export const PRIVACY_SETTINGS_REALTIME_EVENT =
  "privacy-settings:realtime-event";

export const PRIVACY_SETTINGS_STORAGE_EVENT =
  "privacy-settings:realtime-storage-event";

export const emitPrivacySettingsRealtimeEvent = (detail) => {
  window.dispatchEvent(
    new CustomEvent(PRIVACY_SETTINGS_REALTIME_EVENT, { detail }),
  );

  try {
    localStorage.setItem(
      PRIVACY_SETTINGS_STORAGE_EVENT,
      JSON.stringify({
        ...detail,
        emittedAt: Date.now(),
      }),
    );
  } catch (error) {
    console.error("Failed emitting privacy settings storage event", error);
  }
};

export const getPrivacySettingsAffectedUserId = (detail) => {
  const payloads = Array.isArray(detail?.args) ? detail.args : [detail?.args];

  for (const payload of payloads) {
    if (payload && typeof payload === "object" && !Array.isArray(payload)) {
      const userId =
        payload.idUsuario ??
        payload.IdUsuario ??
        payload.userId ??
        payload.UserId ??
        payload.idUser ??
        payload.IdUser ??
        payload.targetUserId ??
        payload.TargetUserId ??
        null;

      if (userId) return userId;
    }
  }

  for (const payload of payloads) {
    if (payload) {
      return payload;
    }
  }

  return null;
};
